import { render } from "./Retired.vue?vue&type=template&id=5620521e&scoped=true"
import script from "./Retired.vue?vue&type=script&lang=ts"
export * from "./Retired.vue?vue&type=script&lang=ts"

import "./Retired.vue?vue&type=style&index=0&id=5620521e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5620521e"

export default script